import { hasDataToRender } from 'PDF/helpers/hasDataToRender';

import { IKeyFeaturesItem } from 'components/BusinessToolForm/Sections/ProductsAndServices/ProductAndServicesDescription/utils/form';
import { IBusinessToolForm } from 'components/BusinessToolForm/utils/form';

export const getProductDescriptionData = (businessPlanChapters: IBusinessToolForm) => {
  const {
    description: { keyFeaturesAndBenefits, qualityCertifications: certifications, patentsOrTrademarks },
  } = businessPlanChapters.PRODUCTS_AND_SERVICES;

  const certificationsData = certifications.map(({ file, value, description }) => ({
    file: file.length > 0 ? file[0].url : '',
    value,
    description,
  })).filter(({ value, description }) => value && description);

  const patentsOrTrademarksData = patentsOrTrademarks.map(({ file, value, description }) => ({
    file: file.length > 0 ? file[0].url : '',
    value,
    description,
  })).filter(({ value, description }) => value && description);

  return {
    characteristics: keyFeaturesAndBenefits
      .map(({ file, value: companyName, description: keyFeaturesDescription }) => ({
        companyImageSrc: file.length > 0 ? file[0].url : '',
        companyName,
        features: (keyFeaturesDescription as IKeyFeaturesItem[]).filter(
          ({ feature, description }) => feature || description,
        ),
      }))
      .filter(({ features }) => features.length > 0),
    certifications: hasDataToRender(certificationsData) ? certificationsData : [],
    patentsOrTrademarks: hasDataToRender(patentsOrTrademarksData) ? patentsOrTrademarksData : [],
  };
};
